'use es6';

import Client from 'AdsUI/data/Client';
import getAccountIdsByNetwork from 'AdsUI/lib/getAccountIdsByNetwork';
const baseUrl = 'ads/v1/tracking';
export const fetchTrackingStatuses = ({
  statuses,
  adAccounts
}) => {
  return Client.apiRequest(`${baseUrl}/statuses-results`, {
    type: 'GET',
    query: Object.assign({}, getAccountIdsByNetwork(adAccounts), {
      status: statuses.toArray()
    })
  });
};
export const fetchTrackingStatusesForCampaign = (network, accountId, campaignId) => {
  return Client.apiRequest(`${baseUrl}/${network}/account/${accountId}/campaign/${campaignId}/statuses`);
};
export const fetchTrackingStatusesForAdGroup = (network, accountId, campaignId, adGroupId) => {
  return Client.apiRequest(`${baseUrl}/${network}/account/${accountId}/campaign/${campaignId}/adgroup/${adGroupId}/statuses`);
};
export const fetchTrackingStatusesForAd = (network, accountId, campaignId, adGroupId, adId) => {
  return Client.apiRequest(`${baseUrl}/${network}/account/${accountId}/campaign/${campaignId}/adgroup/${adGroupId}/ad/${adId}/statuses`);
};
export const refreshTrackingStatus = (network, accountId, entityId) => {
  return Client.apiRequest(`${baseUrl}/${network}/account/${accountId}/entity/${entityId}/refresh`, {
    type: 'PUT'
  });
};
export const dismissTrackingError = tkts => {
  return Client.apiRequest(`${baseUrl}/dismiss`, {
    type: 'PUT',
    query: {
      tkt: tkts
    }
  });
};